<template>
    <div class="x-table-view">
        <div class="x-bar clearfix" v-if="!readonly && hasButtons(config)">
            <x-button-group class="xm-table-button" :config="getButtonsConfig(config)" :data="pData"
                @click="clickHandler"></x-button-group>
        </div>
        <x-table class="xm-table" :config="getConfig(config, allFields)" :readonly="readonly" :datas="modelDatas"
            :index-from="indexFrom" :selected="selectedRows" :total-summary="totalSummary" @button-click="clickHandler"
            @link-click="linkClickHandler" @select="selectHandler" @selection="selectionHandler"
            @sort-changed="sortChangedHandler">
            <template #default>
                <el-popover popper-class="x-table-row-editor" teleported placement="left" :width="250" trigger="click"
                    @hide="saveUserFields()">
                    <template #reference>
                        <el-button class="x-table-row-editor-trigger" :width="16" :icon="SetUp"></el-button>
                    </template>
                    <template #default>
                        <el-table size="small" :max-height="480"
                            :data="getConfigFields(allFields, props.config?.fields, userFields)">
                            <el-table-column prop="name" label="列" width="120"></el-table-column>
                            <el-table-column label="移动" :width="50" align="center" header-align="center">
                                <template #default="scope">
                                    <el-button link :icon="Top" @click="goUp(allFields, scope.row)"
                                        size="small"></el-button>
                                    <el-button link :icon="Bottom" @click="goDown(allFields, scope.row)"
                                        size="small"></el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="显示" :width="45" align="center" header-align="center">
                                <template #default="scope">
                                    <el-switch v-model="scope.row.visible" size="small"></el-switch>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button size="small" style="width:100%; margin-top:5px !important;"
                            @click="() => allFields = null">重置</el-button>
                    </template>
                </el-popover>
            </template>
        </x-table>
        <!-- v-if="config.hasPagination != false && modelDatas && modelDatas.length" -->
        <!-- <x-affix  position="bottom" :offset="0"> -->
        <div class="clearfix" v-if="config.hasPagination != false">
            <div class="x-table-pagination">
                <el-pagination v-model:currentPage="pagination.pageNumber" v-model:pageSize="pagination.pageSize"
                    :total="pagination.total" :page-sizes="[10, 20, 30, 50, 100]" @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler" layout="total, sizes, prev, pager, next, jumper"
                    :proxy="proxy"></el-pagination>
            </div>
        </div>
        <div class="no-pagination" v-else></div>
        <!-- </x-affix> -->
    </div>
</template>
<script setup>
import { reactive, ref, watch, getCurrentInstance, onMounted, nextTick } from 'vue';
import { Plus, Delete, View, Edit, Download, Top, Bottom, SetUp } from '@element-plus/icons-vue';
import XTable from '../components/data/XTable.vue';
import { ElMessage } from 'element-plus'
import XButtonGroup from '../components/base/XButtonGroup.vue';
import XAffix from '../components/base/XAffix.vue';
import FieldType from '../datamodule/FieldType';
import { enter, enterPath, enterUrl } from '../router/RouterPath';
import ViewState from './ViewState';
import DefaultActions from './actions/DefaultActions';
import ModuleCenter from '../datamodule/ModuleCenter';
import { ElMessageBox, ElNotification } from 'element-plus';
import RemoteCenter, { formatDataUrl, getQueryConditions } from '../remoteservice/RemoteCenter';
import SelectType from '../components/data/SelectType';
import { openDialog } from '../dialog/XDialog';
import { addURLParams } from '../tools/URLTools';
import DataPermissionManager from '../datapermission/DataPermissionManager';
import { getRouteCondition, getViewUrl } from '../router/RouterMap';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import { useTokenStore } from '../store/TokenStore';
import { v4 as uuidv4 } from 'uuid'
import { sm3Encode } from '../utils/sm3';
import TableApi from "./api/index"
import ButtonsCode from "../datamodule/ButtonCodes"
import { remoteCall } from '../remoteservice/RemoteService';
import { dayjs } from 'element-plus'
import { Clipboard } from 'v-clipboard'
import TimeService from '../remoteservice/TimeService';
import saveResourceRecord from './ResourceRecord';

const tokenStore = useTokenStore();

const route = useRoute();
const router = useRouter();
const routeCondition = route ? getRouteCondition(route.path) : null;
const inst = getCurrentInstance();

const DEF_TABLE_BUTTONS = [
    { code: 'ADD', name: '新增', icon: Plus, type: "success", },
    { code: 'DELETE_BATCH', name: '选中删除', icon: Delete, batch: true, type: "danger" },
]
const DEF_SELECTION_COLUMN = { type: FieldType.LISTSELECTION, fixed: 'left', width: 30, resizable: false };
const DEF_INDEX_COLUMN = { type: FieldType.INDEX, name: '序号', fixed: 'left', width: 70, resizable: false };
const DEF_TABLE_OPTIONS =
{
    field: 'options', name: '操作', type: FieldType.BUTTON, fixed: 'right', align: 'center', maxCount: 3, buttons: [
        { code: 'VIEW', name: '详情', link: '', size: 'small' },
        { code: 'EDIT', name: '编辑', link: '', size: 'small' },
        { code: 'DELETE', name: '删除', link: '', size: 'small', type: "danger" },
    ], width: 150, resizable: false
}

const formatOptions = (options) => {
    const opts = Object.assign({ name: '操作', fixed: 'right', align: 'center', width: 160, resizabel: false, maxCount: 3, type: FieldType.BUTTON }, options)
    const btns = [];
    for (const button of options.buttons) {
        btns.push(Object.assign({ link: '', size: 'small', type: button.code == 'DELETE' ? 'danger' : 'primary' }, button));
    }
    opts.buttons = btns;
    return opts;
}

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    selected: { default: null },

    queryParams: { default: null },
    parentData: { default: null },

    proxy: { default: null },
    pcode: { default: null },

    data: { default: null },
    filterData: { default: null },
})

const updateFilter = () => {
    if (props.filterData) props.filterData._t = Math.random();
}

const getSortOrders = (fields) => {
    const orders = [];
    for (const field of fields) {
        if (field.sort) orders.push({ direction: field.sort, field: field.field });
    }
    return orders
}
const pagination = reactive({ pageNumber: 1, pageSize: 10, total: 0, orders: getSortOrders(props.config.fields) });

const hashPath = /\#([\w\/]+)/.test(window.location.href) ? RegExp.$1 : '';
const tablePath = ':t-' + hashPath + '/' + props.pcode;
const getUserFields = () => {
    try {
        return JSON.parse(localStorage.getItem(tablePath) || 'null')
    } catch (e) { }
    return null;
}
const userFields = ref(getUserFields())
const saveUserFields = () => {
    try {
        window.localStorage.setItem(tablePath, JSON.stringify(allFields.value));
    } catch (e) {
        ElNotification({ message: '保存失败，浏览器缓存已存满', title: '提示：', type: 'warning' });
    }
}

const getFullCode = (buttons) => {

    if (!buttons.opt) {
        if (!ButtonsCode[buttons.code]) {
            console.log(`%c${buttons.code}`, 'color: red')
        }
        return ButtonsCode[buttons.code] || '-'
    } else {
        return buttons.opt
    }
    // return (props.pcode || '') + (props.config.code ? (+ props.config.code + '/') : '');
}

const modelDatas = ref(props.data || []);
watch(() => props.data, (value) => {
    if (props.config?.fixed) modelDatas.value = value;
})
const selectedRows = ref(null);
const optRow = ref(null);

const totalSummary = ref(null);
// const modelRowData = ref(null);
const indexFrom = ref(0);

const updateNodeData = () => {
    const node = props.config?.node;
    if (!node) return;
    const rows = DataPermissionManager.filterDatas(dataView.value.getModuleCode(), selectedRows.value);
    node.setNodeData({ datas: modelDatas.value, selected: rows, operated: optRow.value, pagination: props.config?.hasPagination !== false ? pagination : null, query: props.queryParams.query, queryOptions: props.queryParams.options, extQuery: extQueryParams.value })
}
const getNodeData = () => {
    const node = props.config?.node;
    if (!node) return null;
    return node.getNodeData();
}

defineEmits({
    'update:selected': null,
    'update:datas': null,
})

const sortChangedHandler = (sorts) => {
    pagination.orders = sorts.map(sort => {
        return { field: sort.field, direction: sort.direction }
    })
    queryDatas()
    // nodeData.result = await dataView.value?.queryDatas({ query: nodeData.query, options: nodeData.queryOptions }, nodeData.extQuery, nodeData.pagination, extData);
}

const getConfig = (config, userconf) => {
    const conf = { ...config };
    conf.module = dataView.value?.getModuleCode();
    conf.fields = getFields(props.config.fields, props.config.defaultFields || ['selection', 'index', 'options'], userconf);
    return conf;
}

const getFields = (fields, defaultFields, userconf) => {
    let inlineButtons = null;
    const dfs = {};
    let dop = null;
    for (const f of fields) {
        if (f.field == 'options') {
            dop = formatOptions(f);
            inlineButtons = f.buttons;
        }
        else dfs[f.field] = f;
    }
    let hasOptions = dop != null;
    let i = 0;
    const fs = [];
    let afs = userconf || fields;
    if (!hasOptions && afs.length != fields.length || hasOptions && afs.length != fields.length - 1) afs = fields;
    for (const f of afs) {
        const field = f.field;
        if (f.visible === false) continue;
        if (field == 'options') {
            continue;
        } else {
            fs.push(dfs[field]);
        }
        i++
    }
    if (dop) fs.push(dop);
    for (let i = defaultFields.length - 1; i >= 0; i--) {
        const field = defaultFields[i];
        switch (field) {
            case 'selection': fs.unshift(DEF_SELECTION_COLUMN); break;
            case 'index': fs.unshift(DEF_INDEX_COLUMN); break;
            case 'options':
                if (!hasOptions) {
                    fs.push(DEF_TABLE_OPTIONS);
                    inlineButtons = DEF_TABLE_OPTIONS.buttons;
                }
                break;
        }
    }
    if (inlineButtons && inlineButtons.length) {
        for (const button of inlineButtons) {

            const fullCode = getFullCode(button);
            button.fullCode = button.code;
            button.opt = fullCode
            button.module = button.entity || dataView.value.getModuleCode()
        }
    }
    return fs;
}
const checkModel = async (datas, view) => {
    const options = { "config": "SORULEMODEL_SELECTION", "dialogField": "ids", "keyField": "id", "selectType": 1 }
    const dialogData = await openDialog(Object.assign({}, options), null, {});
    if (!dialogData) {
        console.log(11111)
    } else {
        if (!dialogData['selected']) {
            ElMessageBox.alert('请选择分成条款模板', '提示：', { type: 'warning' });
            return;
        }
        const keys = view.datasKeys(datas, 'id');
        const query = Object.assign({}, props.queryParams);
        Object.assign(query.query, { id: keys })
        const conditions = { queryCondition: getQueryConditions(query) };
        const res = await remoteCall('/dev-api/lms/fmpSoPoRule/genSoPoRuleAgainByQcModel/' + dialogData['selected'], { data: conditions });
        console.log('convert result', res);
    }

}
const allFields = ref(null);
const getConfigFields = (defFields, fields, userconf) => {
    if (defFields) return defFields;
    const dfs = {};
    for (const f of fields) {
        if (f.field == 'options') continue;
        else dfs[f.field] = f;
    }
    const fs = [];
    for (const f of userconf || fields) {
        const field = f.field || f;
        if (field == 'options' || !dfs[field]) continue;
        else fs.push({ field: field, name: f.name, visible: f.visible !== false });
    }
    return allFields.value = fs;
}

const goUp = (fields, row) => {
    const index = fields.indexOf(row);
    if (index >= 1) {
        const data = fields[index - 1];
        fields[index - 1] = row;
        fields[index] = data;
    }
}
const goDown = (fields, row) => {
    const index = fields.indexOf(row);
    if (index < fields.length - 1) {
        const data = fields[index + 1];
        fields[index + 1] = row;
        fields[index] = data;
    }
}

const dataView = ref(null);
watch(() => props.config?.view, (value) => {
    dataView.value = value;
    if (value && modelDatas.value && modelDatas.value.length) {
        value.fillDatas(modelDatas.value);
    }
}, { immediate: true })

const pData = ref(null);

const keyData = ref(null);
watch(() => props.config, (value) => {
    keyData.value = value?.node?._parent?._data;
    pData.value = Object.assign({}, route.query, keyData.value);
    // console.log(pData)
}, { immediate: true, deep: true })

const chars = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's',
    't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
    'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
function shortUuid() {
    let shortBuffer = ''
    let uuidStr = uuidv4()
    uuidStr = uuidStr.replace(/-/g, '')
    for (var i = 0; i < 8; i++) {
        const str = uuidStr.substring(i * 4, i * 4 + 4)
        const x = parseInt(str, 16)
        shortBuffer += chars[x % 0x3E]
    }
    return shortBuffer
}
const download = async (data, view) => {
    // const tokenStore = useTokenStore();
    const url = '/dev-api/tat/sysReadOperationBuriedPoint/download/' + data.id;
    let dataStr = '{}'

    let objdata = {
        data: dataStr
    }
    const timestamp = Date.now()
    // dataStr = JSON.stringify(obj)
    dataStr = dataStr.replace(/\"/g, '')
    let dataStr1 = JSON.stringify(objdata)
    dataStr1 = dataStr1.replace(/\"/g, '')
    const sign = 'Timestamp' + timestamp + dataStr
    // sign = sign.replace(/\"/g, '')
    const sign1 = 'Timestamp' + timestamp + dataStr1

    let urlKey = {
        url: url
    }
    let urlKeys = JSON.stringify(urlKey)

    urlKeys = urlKeys.replace(/\"/g, '')
    const signUrl = 'Timestamp' + timestamp + urlKeys
    const timestampStr = timestamp
    const nonceStr = shortUuid()
    axios({
        url,
        method: 'GET',
        responseType: 'blob',
        headers: {
            'Authorization': 'Bearer ' + tokenStore.token,
            'X-Ca-Sign': sm3Encode(sign).toUpperCase(),
            'X-Ca-Timestamp': timestampStr,
            'X-Ca-Datasign': sm3Encode(sign1).toUpperCase(),
            'X-Ca-Urlsign': sm3Encode(signUrl).toUpperCase(),
            'X-Ca-Nonce': nonceStr,
            'X-Ca-Nonce-TT': sm3Encode(timestampStr + nonceStr).toUpperCase()
        }
    }).then(response => {
        var blob = new Blob([response.data])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = data.fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    })
}
const TABDOWN = async (datas, view) => {
    let dataStr = '{}'

    let objdata = {
        data: dataStr
    }
    const timestamp = Date.now()
    // dataStr = JSON.stringify(obj)
    dataStr = dataStr.replace(/\"/g, '')
    let dataStr1 = JSON.stringify(objdata)
    dataStr1 = dataStr1.replace(/\"/g, '')
    const sign = 'Timestamp' + timestamp + dataStr
    // sign = sign.replace(/\"/g, '')
    const sign1 = 'Timestamp' + timestamp + dataStr1

    let urlKey = {
        url: '/dev-api/lms/fmpOrderImpl/exportSettlement/' + view.datasKeys(datas)
    }
    let urlKeys = JSON.stringify(urlKey)

    urlKeys = urlKeys.replace(/\"/g, '')
    const signUrl = 'Timestamp' + timestamp + urlKeys
    const timestampStr = timestamp
    const nonceStr = shortUuid()
    axios({
        url: '/dev-api/lms/fmpOrderImpl/exportSettlement/' + view.datasKeys(datas),
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + tokenStore.token,
            'X-Ca-Sign': sm3Encode(sign).toUpperCase(),
            'X-Ca-Timestamp': timestampStr,
            'X-Ca-Datasign': sm3Encode(sign1).toUpperCase(),
            'X-Ca-Urlsign': sm3Encode(signUrl).toUpperCase(),
            'X-Ca-Nonce': nonceStr,
            'X-Ca-Nonce-TT': sm3Encode(timestampStr + nonceStr).toUpperCase()
        },
        data: { queryCondition: getQueryConditions(Object.assign({}, props.queryParams)) }
    }).then((response) => {
        if (response.data.code != 200) {
            ElMessage.error(response.data.msg)
        } else {
            const a = document.createElement('a')
            a.href = response.data.msg;
            const date = new Date();
            a.download = (date.getMonth() + 1) + '-' + date.getDate() + '-' + `icourse-模拟分成结果.xls`
            a.click()
        }
    })
}

const TABLEEXPORT = async (datas, view) => {
    console.log(props.queryParams.query)
    let dataStr = '{}'

    let objdata = {
        data: dataStr
    }
    const timestamp = Date.now()
    // dataStr = JSON.stringify(obj)
    dataStr = dataStr.replace(/\"/g, '')
    let dataStr1 = JSON.stringify(objdata)
    dataStr1 = dataStr1.replace(/\"/g, '')
    const sign = 'Timestamp' + timestamp + dataStr
    // sign = sign.replace(/\"/g, '')
    const sign1 = 'Timestamp' + timestamp + dataStr1
    const urlKey = {}
    if (view._config.module == 'fmpOrder' && props.queryParams.query.orderType == 'so') {
        urlKey.url = '/dev-api/lms/' + view._config.module + '/fmpOrder_so/export'
    } else if (view._config.module == 'fmpOrder' && props.queryParams.query.orderType == 'po') {
        urlKey.url = '/dev-api/lms/' + view._config.module + '/fmpOrder_po/export'
    } else if (view._config.module == 'fmpContract' && props.queryParams.query.contractType == 'sales') {
        urlKey.url = '/dev-api/lms/' + view._config.module + '/fmpContract_so/export'
    } else if (view._config.module == 'fmpContract' && props.queryParams.query.contractType == 'purchase') {
        urlKey.url = '/dev-api/lms/' + view._config.module + '/fmpContract_po/export'
    } else {
        urlKey.url = '/dev-api/lms/' + view._config.module + '/export'
    }
    // let urlKey = {
    //     url: '/dev-api/lms/'+view._config.module+'/export'
    // }
    let urlKeys = JSON.stringify(urlKey)

    urlKeys = urlKeys.replace(/\"/g, '')
    const signUrl = 'Timestamp' + timestamp + urlKeys
    const timestampStr = timestamp
    const nonceStr = shortUuid()
    axios({
        url: urlKey.url,
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + tokenStore.token,
            'X-Ca-Sign': sm3Encode(sign).toUpperCase(),
            'X-Ca-Timestamp': timestampStr,
            'X-Ca-Datasign': sm3Encode(sign1).toUpperCase(),
            'X-Ca-Urlsign': sm3Encode(signUrl).toUpperCase(),
            'X-Ca-Nonce': nonceStr,
            'X-Ca-Nonce-TT': sm3Encode(timestampStr + nonceStr).toUpperCase()
        },
        data: { queryCondition: getQueryConditions(Object.assign({}, props.queryParams)) }
    }).then((response) => {
        if (response.data.code != 200) {
            ElMessage.error(response.data.msg)
        } else {
            const a = document.createElement('a')
            a.href = response.data.msg;
            const date = new Date();
            let name = response.data.msg.slice(5);
            a.download = name;
            a.click()
        }
    })
}

const modifySaveData = async (data, view, modify) => {
    // data = Object.assign(data, modify);
    for (const [k, v] of Object.entries(modify)) {
        let value = v;
        if (v == '{loginUser}') value = tokenStore.userid;
        else if (v == '{loginUserName}') value = tokenStore.username;
        else if (v == '{now}') value = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss');
        data[k] = value;
    }
    const result = await view.saveData(data);
    return true;
}
const modifySaveDatas = async (datas, view, modify) => {
    for (const data of datas) {
        // Object.assign(data, modify);
        for (const [k, v] of Object.entries(modify)) {
            let value = v;
            if (v == '{loginUser}') value = tokenStore.userid;
            else if (v == '{loginUserName}') value = tokenStore.username;
            else if (v == '{now}') value = dayjs(TimeService.getServerTimeStamp()).format('YYYY-MM-DD HH:mm:ss');
            data[k] = value;
        }
    }
    const result = await view.saveDatas(datas);
    return true;
}
const collect = async (datas, view) => {
    const def = { userId: tokenStore.userid };
    const collects = [];
    for (const d of datas) {
        const data = Object.assign({}, def, { entityId: d.id, entityType: view.getModule().getCode() });
        collects.push(data)
    }
    const module = ModuleCenter.getModule('favourite');
    const res = await module.createDatas(collects);
    return res;
}
const uncollect = async (datas, view) => {
    const ids = datas.map(data => data.id);
    const query = { userId: tokenStore.userid, entityId: ids, entityType: view.getModule().getCode() };
    const module = ModuleCenter.getModule('favourite');
    const collects = await module.queryDatas({ query });
    if (!collects.length) return;
    const keys = module.datasKeys(collects);
    const res = await module.deleteDatasByKeys(keys);
    return res;
}

const queryDatas = async () => {
    if (props.config?.fixed) return;
    if (!props.queryParams) return;
    const queryParams = Object.assign({}, props.queryParams);
    if (queryParams.query) delete queryParams.query['_t'];
    // TODO:以下部分需要整理
    updateNodeData();
    if (pagination && pagination.pageNumber == 0) pagination.pageNumber = 1;
    const nodeData = getNodeData() || { query: props.queryParams.query, queryOptions: props.queryParams.options, extQuery: extQueryParams.value, pagination: props.config.hasPagination !== false ? pagination : null };
    const queryData = await props.proxy?.onBeforeLoadDatas(dataView.value.getCode() || dataView.value.getModuleCode(), nodeData);

    const extData = {};
    if (queryData) {
        if (queryData.result) {
            // data = queryData.result;
        } else if (queryData.url) {
            queryData.result = await dataView.value?.queryDatasWithUrl(queryData.url, { query: queryData.query, options: queryData.queryOptions, method: queryData.method }, queryData.extQuery, queryData.pagination, extData);
        } else {
            queryData.result = await dataView.value?.queryDatas({ query: nodeData.query, options: nodeData.queryOptions }, nodeData.extQuery, nodeData.pagination, extData);
        }
    } else {
        nodeData.result = await dataView.value?.queryDatas({ query: nodeData.query, options: nodeData.queryOptions }, nodeData.extQuery, nodeData.pagination, extData);
    }
    if (extData.summary) {
        totalSummary.value = extData.summary;
    }
    let data = queryData || nodeData;
    if (!data.result) return;
    updateNodeData();
    const resData = await props.proxy?.onAfterLoadDatas(dataView.value.getCode() || dataView.value.getModuleCode(), data);
    data = resData || data;
    const datas = data.result.data;
    if (props.config.hasPagination != false) {
        pagination.total = data.result.pagination.total;
        pagination.pageNumber = data.result.pagination.pageNumber || 1;
        indexFrom.value = (pagination.pageNumber - 1) * pagination.pageSize;
    }
    modelDatas.value = datas;
    if (inst.refs.table) inst.refs.table['forceUpdate']();
    inst.emit('update:datas', datas);
}

const getExtQuery = (relations, data) => {
    // 有部分内容需要和后端确认
    // 扩展通用跨表查询接口中查询条件中某天个字段， in 类型，增加 SQL 条件，如 (select ModuleC.bid from ModuleC where ModuleC.aid in (select ModuleA.aid from ModuleA where ModuleA.xxx = xxx))
    if (relations instanceof Array) {
        const query = [];
        for (const relation of relations) {
            query.push(Object.assign({}, relation, { value: relation.srcValue || (data ? data[relation.srcField] : null) }));
        }
        return query;
    } else {
        return Object.assign({}, relations, { value: data ? data[relations.srcField] : null });
    }
}

const extQueryParams = ref(null);
watch(() => keyData.value, (value) => {
    // if (props.config?.node?._parent && value == null) return;
    const relations = props.config?.node?.getRelations();
    if (relations && value == null) return;
    if (value) {
        extQueryParams.value = getExtQuery(relations, value);
    }
    queryDatas();
}, { immediate: true })

// 根据当前 module 和 上级 module 的关联关系来确定 keyData
// const getKeyData = (parentData)=> {
//     if (!parentData) return null;
//     return dataView.value?.getMappedKeyData(parentData.data, parentData.module, props.config.relField);
// }
// const keyData = ref(getKeyData(props.parentData));

const updateSelectedWithDefault = (rows, defaultSelected) => {
    if (!defaultSelected) defaultSelected = [];
    if (!(defaultSelected instanceof Array)) defaultSelected = [defaultSelected];
    const keyField = props.config?.keyField || dataView.value.defaultKeyField();
    const selected = [];
    const keyMap = new Map();
    for (const data of defaultSelected) {
        if (data instanceof Object) {
            keyMap.set(data[keyField], true);
        } else {
            keyMap.set(data, true);
        }
    }
    for (const row of rows) {
        if (keyMap.get(row[keyField])) selected.push(row);
    }
    if (props.config?.selectType != SelectType.SINGLE_SELECT) {
        selectedRows.value = selected;
    } else {
        selectedRows.value = selected && selected.length ? selected[0] : null;
    }
}

watch(() => props.selected, (value) => {
    updateSelectedWithDefault(modelDatas.value, value);
})
watch(() => modelDatas.value, (value) => {
    nextTick(() => updateSelectedWithDefault(value, props.selected));
})

const checkFuncPermission = (ctrls, nodeData, permisstions) => {
    return ctrls;
    console.log('check permission', ctrls, nodeData);
}
const hasButtons = (config) => {
    return config.buttons && config.buttons.length || config.withDefaultButtons;
}
const getButtonsConfig = (config) => {
    // console.log('full code', getFullCode());
    let buttonMap = null;
    if (config.tableButtons) {
        for (const tbtn of config.tableButtons) {
            if (!buttonMap) buttonMap = {};
            buttonMap[tbtn.code] = tbtn;
        }
    }
    const testTableButton = (button) => {
        const mapConf = buttonMap[button.code];
        if (!mapConf) return false;
        if (mapConf.name) button.name = mapConf.name;
        return true;
    }

    let buttons = null;
    if (!config.withDefaultButtons && (!config.buttons || !config.buttons.length)) buttons = null;
    else {
        const actualButtons = config.withDefaultButtons ? DEF_TABLE_BUTTONS.slice() : [];
        if (config.buttons && config.buttons.length) {
            for (const btn of config.buttons) {
                for (let i = 0; i < actualButtons.length; i++) {
                    const abtn = actualButtons[i];
                    if (btn.code == abtn.code) {
                        for (const [k, v] of Object.entries(btn)) {
                            if (v === undefined) delete btn[k];
                        }
                        const xbtn = Object.assign({}, abtn, btn);
                        Object.assign(btn, xbtn);
                        actualButtons.splice(i, 1);
                        break;
                    }
                }
            }
        }
        if (config.buttons && config.buttons.length) buttons = actualButtons.concat(config.buttons);
        else buttons = actualButtons.length ? actualButtons : null;
    }
    const filters = [];
    for (const button of buttons) {
        if (!config.tableButtons || testTableButton(button)) {
            const fullCode = getFullCode(button);
            button.fullCode = button.code;
            // console.log(button)
            button.opt = fullCode;
            button.module = button.entity || dataView.value.getModuleCode();
            filters.push(button);
        }
    }
    buttons = filters;
    return { align: 'left', grouped: false, buttons: buttons };
}
const goLink = async (row, view, config) => {
    const urlInfo = formatDataUrl(config.url, row);
    router.push({ path: urlInfo.url, query: urlInfo.params });
    // console.log(url);
}
const viewData = (data, view, module) => {
    if (!view) return;
    if (!module) module = view.getModuleCode();
    const key = view.dataKey(data);
    const keyField = view.defaultKeyField();
    if (DataPermissionManager.checkDataPermission(module, data))
        return enter(module + '.' + keyField, key, ViewState.VIEW, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
    else return enter(module + '.' + keyField, key, ViewState.VIEW | ViewState.READONLY, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
}

const viewReadData = (data, view, module) => {
    if (!view) return;
    if (!module) module = view.getModuleCode();
    const key = view.dataKey(data);
    const keyField = view.defaultKeyField();
    if(data.isRead=='未读'){
        remoteCall('/dev-api/system/userMessage/read/' + key, { type: 'get' });
    }
    if (DataPermissionManager.checkDataPermission(module, data))
        return enter(module + '.' + keyField, key, ViewState.VIEW, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
    else return enter(module + '.' + keyField, key, ViewState.VIEW | ViewState.READONLY, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
}

const viewEntityData = (data, view) => {
    if (!view) return;
    const module = data.entityType || data.newEntityType;
    const key = data.entityId || data.newEntityId;
    console.log('-------', module, key)
    const keyField = view.defaultKeyField();
    if (DataPermissionManager.checkDataPermission(module, data))
        return enter(module + '.' + keyField, key, ViewState.VIEW, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
    else return enter(module + '.' + keyField, key, ViewState.VIEW | ViewState.READONLY, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
}

const summaryDatas = async (datas, view) => {
    const summaryFields = view.getSummaryFields();
    const nodeData = getNodeData() || { query: props.queryParams.query, queryOptions: props.queryParams.options, extQuery: extQueryParams.value, pagination: props.config.hasPagination !== false ? pagination : null };
    const conditions = getQueryConditions({ query: nodeData.query, options: nodeData.queryOptions }, nodeData.extQuery);
    const summary = await view.do('/dev-api/lms/' + view.getModuleCode() + '/summary', { queryCondition: conditions, summaryFields: summaryFields });
    if (summary && summary.data) {
        const summaryDatas = summary.data;
        for (const [field, value] of Object.entries(summaryDatas)) {
            summaryDatas[field] = parseFloat(value).toFixed(2);
        }
        totalSummary.value = summaryDatas;
    }
}

const deleteDatas = async (datas, view, relModules) => {
    if (!view) return;
    if (relModules && relModules.length) {
        for (const relModule of relModules) {
            const relations = ModuleCenter.testRelations([view.getModule().getCode(), relModule]);
            if (relations.length == 1) {
                const relation = view.getModule().getModuleRelation(relModule);
                const keys = datas.map((data) => data[relation.srcField] + '');
                const query = {};
                query[relation.destField] = keys;
                const relDatas = await relation.relModule.queryDatas({ query });
                if (!relDatas.length) continue;
                const relKeys = relation.relModule.datasKeys(relDatas);
                const res = await relation.relModule.deleteDatasByKeys(relKeys);
                // console.log(res);
            } else if (relations.length == 2) {
                let key = '';
                let field = '';
                let rModule = '';
                relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
                    rModule = $1;
                    key = $2;
                })
                relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
                    field = $1;
                })
                const keys = datas.map((data) => data[field] + '');
                const query = {};
                query[key] = keys;
                const module = ModuleCenter.getModule(rModule);
                const relDatas = await module.queryDatas({ query });
                if (!relDatas.length) continue;
                const relKeys = module.datasKeys(relDatas);
                const res = await module.deleteDatasByKeys(relKeys);
                // console.log(res)
            }
        }
    }
    return await view.deleteDatas(datas);
}

const TRYRESOURCE = async (datas, view) => {
    // console.log(datas,view,props.queryParams.query)
    let par = {
        queryCondition: getQueryConditions(Object.assign({}, props.queryParams)),
        otherCondition: { ids: view.datasKeys(datas, 'id').toString() }
    }
    TableApi.postMethods('/dev-api/ebk/ebkResource/batchCutVideo', par)
}
const TATTRYRESOURCE = async (datas, view) => {
    // console.log(datas,view,props.queryParams.query)
    let par = {
        queryCondition: getQueryConditions(Object.assign({}, props.queryParams)),
        otherCondition: { ids: view.datasKeys(datas, 'id').toString() }
    }
    TableApi.postMethods('/dev-api/tat/tatResource/batchCutVideo', par)
}
const deleteRels = async (datas, view) => {
    const nodeData = getNodeData();
    if (!nodeData || !nodeData._parent) return;
    const parentData = nodeData._parent.data;
    if (!parentData) return;
    const parentModule = nodeData._parent.module;

    const module = view.getModuleCode();

    const relations = ModuleCenter.testRelations([module, parentModule]);
    if (relations.length < 2) return;
    let key = '';
    let field = '';
    let relKey = '';
    let relField = '';
    let rModule = '';
    relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
        rModule = $1;
        key = $2;
    })
    relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        field = $1;
    })
    relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relKey = $1;
    })
    relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relField = $1;
    })
    const relData = {};
    relData[relKey] = parentData[relField];
    const relModule = ModuleCenter.getModule(rModule);

    const conditions = { query: {}, options: {} };
    Object.assign(conditions.query, relData);
    const values = [];
    for (const d of datas) {
        values.push(d[field])
    }
    conditions.query[key] = values;
    const entityField = relModule._bindEntity?.typeField;
    if (entityField) {
        conditions.query[entityField] = [parentModule, module];
    }
    const relDatas = await relModule.queryDatas(conditions);
    const keys = relModule.datasKeys(relDatas, 'id');
    return relModule.deleteDatasByKeys(keys);
}
const deleteTreeRels = async (tree, datas, view) => {
    const treeModule = tree.module;
    const treeData = tree.data;
    const module = view.getModuleCode();

    const relations = ModuleCenter.testRelations([module, treeModule]);
    if (relations.length < 2) return;
    let key = null;
    let field = null;
    let relKey = null;
    let relField = null;
    let rModule = null;
    relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
        rModule = $1;
        key = $2;
    })
    relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        field = $1;
    })
    relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relKey = $1;
    })
    relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relField = $1;
    })
    const relData = {};
    relData[relKey] = treeData[relField];
    const relModule = ModuleCenter.getModule(rModule);

    const conditions = { query: {}, options: {} };
    Object.assign(conditions.query, relData);
    const values = [];
    for (const d of datas) {
        values.push(d[field])
    }
    conditions.query[key] = values;
    const entityField = relModule._bindEntity?.typeField;
    if (entityField) {
        conditions.query[entityField] = [treeModule, module];
    }
    const relDatas = await relModule.queryDatas(conditions);
    const keys = relModule.datasKeys(relDatas, 'id');
    return relModule.deleteDatasByKeys(keys);
}
const addDatas = async (view, sourceDialog) => {
    if (!view) return;
    const res = await openDialog({ config: sourceDialog })
    if (!res) return;
    const relModule = res.module;
    const relation = view.getModule().getModuleRelation(relModule);
    const datas = [];
    for (const d of res.data) {
        const data = {};
        data[relation.srcField] = d[relation.destField];
        datas.push(data);
    }
    const r = await view.getModule().createDatas(datas);
    console.log(r);
    return r;
}
const addTargetDatas = async (row, view, targetModule, targetMap, sourceDialog) => {
    if (!view) return;
    const res = await openDialog({ config: sourceDialog })
    if (!res) return;
    const relModule = res.module;
    const relation = ModuleCenter.getModule(targetModule).getModuleRelation(relModule);
    const cRelation = view.getModule().getModuleRelation(targetModule);
    const datas = [];
    for (const d of res.data) {
        const data = {};
        data[relation.srcField] = d[relation.destField];
        data[cRelation.destField] = row[cRelation.srcField];
        if (targetMap) {
            for (const [mapField, field] of Object.entries(targetMap)) {
                data[mapField] = row[field];
            }
        }
        datas.push(data);
    }
    const r = await ModuleCenter.getModule(targetModule).createDatas(datas);
    console.log(r);
    return r;
}
const addSelectTargetDatas = async (rows, view, modify, targetModule, targetMap, sourceDialog, selectType) => {
    if (!view) return;
    const res = await openDialog({ config: sourceDialog, selectType })
    if (!res) return;
    const relModule = res.module;
    const relation = ModuleCenter.getModule(targetModule).getModuleRelation(view.getModule().getCode());
    const cRelation = ModuleCenter.getModule(relModule).getModuleRelation(targetModule);

    const modifyDatas = [];
    const datas = [];

    for (const d of rows) {
        if (modify) modifyDatas.push(Object.assign(d, modify));
        const data = {};
        data[relation.srcField] = d[relation.destField];
        data[cRelation.destField] = res.data[cRelation.srcField];
        if (targetMap) {
            for (const [mapField, field] of Object.entries(targetMap)) {
                data[mapField] = res.data[field];
            }
        }
        datas.push(data);
    }
    if (modify && modifyDatas.length) {
        await view.getModule().editDatas(modifyDatas);
    }

    const r = await ModuleCenter.getModule(targetModule).createDatas(datas);
    console.log(r);
    return r;
}
const addDatasWithParent = async (parentData, view, module, map, sourceDialog, selectType) => {
    if (!view) return;
    const res = await openDialog({ config: sourceDialog, selectType })
    if (!res) return;

    let ds = res.data;
    if (module) {
        const relation = ModuleCenter.getModule(res.module).getModuleRelation(module);
        if (!(ds instanceof Array)) ds = [ds];
        const keys = ds.map((d) => d[relation.srcField]);
        const query = {};
        query[relation.destField] = keys;
        ds = await ModuleCenter.getModule(module).queryDatas({ query });
    } else {
        module = res.module;
    }

    const relModule = module;
    const relation = view.getModule().getModuleRelation(relModule);
    const datas = [];
    for (const d of ds) {
        let data = {};
        data[relation.srcField] = d[relation.destField];
        if (map && parentData) {
            for (const [mapField, field] of Object.entries(map)) {
                data[mapField] = parentData[field]
            }
        } else {
            data = Object.assign(data, parentData);
        }
        datas.push(data);
    }
    const r = await view.getModule().createDatas(datas);
    console.log(r);
    return r;
}
const addRels = async (view, sourceDialog, modify) => {
    const nodeData = getNodeData();
    if (!nodeData || !nodeData._parent) return;
    const parentData = nodeData._parent.data;
    if (!parentData) return;
    const parentModule = nodeData._parent.module;

    const module = view.getModuleCode();

    const relations = ModuleCenter.testRelations([module, parentModule]);
    if (relations.length < 2) return;
    let key = '';
    let field = '';
    let relKey = '';
    let relField = '';
    let rModule = '';
    relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
        rModule = $1;
        key = $2;
    })
    relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        field = $1;
    })
    relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relKey = $1;
    })
    relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relField = $1;
    })
    const relData = {};
    relData[relKey] = parentData[relField];
    const relModule = ModuleCenter.getModule(rModule);

    const res = await openDialog({ config: sourceDialog });
    if (!res) return;
    if (!res.data || !res.data.length) {
        return;
    }

    const modifyDatas = [];
    const datas = [];
    console.log(res.data)
    for (const data of res.data) {
        if (modify) modifyDatas.push(Object.assign(data, modify));
        const d = Object.assign({}, relData);
        d[key] = data[field];
        datas.push(d);
    }
    if (modify && modifyDatas.length) {
        await ModuleCenter.getModule(res.module).editDatas(modifyDatas);
    }

    const r = await relModule.createDatas(datas);
    console.log(r);
    return r;
}

const anweraddRels = async (view, sourceDialog, modify) => {
    const nodeData = getNodeData();
    if (!nodeData || !nodeData._parent) return;
    const parentData = nodeData._parent.data;
    if (!parentData) return;
    const parentModule = nodeData._parent.module;

    const module = view.getModuleCode();

    const relations = ModuleCenter.testRelations([module, parentModule]);
    if (relations.length < 2) return;
    let key = '';
    let field = '';
    let relKey = '';
    let relField = '';
    let rModule = '';
    relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
        rModule = $1;
        key = $2;
    })
    relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        field = $1;
    })
    relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relKey = $1;
    })
    relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relField = $1;
    })
    const relData = {};
    relData[relKey] = parentData[relField];
    const relModule = ModuleCenter.getModule(rModule);

    const res = await openDialog({ config: sourceDialog });
    if (!res) return;
    if (!res.data || !res.data.length) {
        return;
    }

    const modifyDatas = [];
    const datas = [];
    console.log(res.data)
    for (const data of res.data) {
        if (modify) modifyDatas.push(Object.assign(data, modify));
        const d = Object.assign({}, relData);
        d[key] = data[field];
        datas.push(d);
    }
    if (modify && modifyDatas.length) {
        await ModuleCenter.getModule(res.module).editDatas(modifyDatas);
    }

    const r = await relModule.createDatas(datas);
    console.log(r);
    return r;
}
const addTreeRels = async (tree, view, sourceDialog, modify) => {
    const treeModule = tree.module;
    const treeData = tree.data;
    const module = view.getModuleCode();

    const relations = ModuleCenter.testRelations([module, treeModule]);
    if (relations.length < 2) return;
    let key = '';
    let field = '';
    let relKey = '';
    let relField = '';
    let rModule = '';
    relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
        rModule = $1;
        key = $2;
    })
    relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        field = $1;
    })
    relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relKey = $1;
    })
    relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relField = $1;
    })
    const relData = {};
    relData[relKey] = treeData[relField];
    const relModule = ModuleCenter.getModule(rModule);

    const res = await openDialog({ config: sourceDialog });
    if (!res) return null;
    if (!res.data || !res.data.length) {
        return;
    }

    const modifyDatas = [];
    const datas = [];
    for (const data of res.data) {
        if (modify) modifyDatas.push(Object.assign(data, modify));
        const d = Object.assign({}, relData);
        d[key] = data[field];
        datas.push(d);
    }
    if (modify && modifyDatas.length) {
        await ModuleCenter.getModule(res.module).editDatas(modifyDatas);
    }

    const r = await relModule.createDatas(datas);
    console.log(r);
    return r;
}

const editData = (data, view) => {
    if (!view) return;
    const module = view.getModuleCode();
    const key = view.dataKey(data);
    const keyField = view.defaultKeyField();
    return enter(module + '.' + keyField, key, ViewState.EDIT, Object.assign({}, props.config?.node?.getParentRelData(), props.config?.filter));
}

const addRootData = (tree, data, view, r) => {
    // if (!view) return;
    // const module = view.getModule();
    // const rel = module.getModuleRelation(module.getCode());
    // data[rel.srcField] = tree.data[rel.destField];
    return addData(data, view, r);
}
const addChildData = (tree, data, view, r) => {
    if (!view) return;
    const module = view.getModule();
    const rel = module.getModuleRelation(module.getCode());
    data[rel.srcField] = tree.data[rel.destField];
    return addData(data, view, r);
}
const addData = (data, view, r) => {
    if (!view) return;
    const module = view.getModuleCode();
    const keyField = view.defaultKeyField();
    const bizDomain = route.query.bizDomain || undefined;
    return enter(module + '.' + keyField, '', ViewState.CREATE, Object.assign({ bizDomain: bizDomain }, props.config?.node?.getParentRelData(), data, props.config?.filter, props.filterData ? { _tree: JSON.stringify(props.filterData) } : null), r);
}
const addDataWithParent = (parentData, map, view) => {
    if (!view) return;
    const module = view.getModule().getCode();
    const keyField = view.defaultKeyField();
    const bizDomain = route.query.bizDomain || undefined;
    let data = {};
    if (map && parentData) {
        for (const [mapField, field] of Object.entries(map)) {
            data[mapField] = parentData[field]
        }
    } else {
        data = Object.assign({}, parentData);
    }
    return enter(module + '.' + keyField, '', ViewState.CREATE, Object.assign({ bizDomain: bizDomain }, data, props.config?.filter));
}

const activeData = async (data, view) => {
    const d = await setDataActive(data, view, true);
    if (d) data.status = '0';
    console.log(d);
}
const deactiveData = async (data, view) => {
    const d = await setDataActive(data, view, false);
    if (d) data.status = '1';
    console.log(d);
}

const activeDataUser = async (data, view) => {
    console.log(data)
    let per ={
        userId:data.userId,
        status:'0'
    }
    await remoteCall('/dev-api/system/user/changeProfile',  { params: null, data: per, loadingState: 0,type:'put' }, true);
}
const deactiveDataUser = async (data, view) => {
    console.log(data)
    let per ={
        userId:data.userId,
        status:'1'
    }
    await remoteCall('/dev-api/system/user/changeProfile',  { params: null, data: per, loadingState: 0,type:'put' }, true);
}


const activeDatatat = async (data, view) => {
    const d = await tatDataActive(data, view, true);
    if (d) data.status = '0';
    console.log(d);
}
const deactiveDatatat = async (data, view) => {
    const d = await tatDataActive(data, view, false);
    if (d) data.status = '1';
    console.log(d);
}

const reads = async (datas, view) => {
    const keys = view.datasKeys(datas, 'id');
    console.log(keys)
    return  await remoteCall('/dev-api/system/userMessage/read/' + keys, { type: 'get' });
}

const invalidData = async (data, view) => {
    data.orderStatus = 'canceled';
    return saveRow(data, view);
}
const closeData = async (data, view) => {
    data.orderStatus = 'closed';
    return close(data, view);
}
const close = async (data, view) => {
    // data.orderStatus = 'closed';
    // return saveRow(data, view);
    const keys = view.dataKey(data);
    return view.do('/dev-api/fmcash/' + view.getModuleCode() + '/close/' + keys, {});
}
const copyLink = async (data, view, nameField, module) => {
    const url = getViewUrl(data, module || view.getModuleCode());
    const name = data[nameField || 'name'];
    const link = `${url}\n#${name || ''}#`;
    await Clipboard.copy(link);
}
const copyPreview = async (data, view, nameField)=> {
    // const url = '/learning/onlinelearning?recordId=146';
    console.log(data)
    const newLink = window.location.origin + window.location.pathname + `#/learning/copyPreview?resourceId=${data.resourceId}`
    await Clipboard.copy(newLink);
}
const moveInto = async (tree, view, modify, sourceDialog, selectType) => {
    const res = await openDialog({ config: sourceDialog, selectType });
    if (!res) return;
    const datas = res.data;
    if (!datas || !datas.length) {
        return;
    }
    const rm = tree.module;
    const rData = tree.data;
    const module = view.getModuleCode();

    const relation = view.getModule().getModuleRelation(rm);
    if (!relation) return;
    for (const data of datas) {
        data[relation.srcField] = rData[relation.destField];
    }
    console.log(relation);

    return await view.getModule().editDatas(datas);
}
const moveTo = async (datas, view, modify, sourceDialog, selectType) => {
    if (!datas || !datas.length) {
        return;
    }
    const res = await openDialog({ config: sourceDialog, selectType });
    if (!res) return;
    const rm = res.module;
    const rData = res.data;
    const module = view.getModuleCode();

    const relation = view.getModule().getModuleRelation(rm);
    if (!relation) return;
    for (const data of datas) {
        data[relation.srcField] = rData[relation.destField];
    }
    console.log(relation);

    return await view.getModule().editDatas(datas);
}
const copyTo = async (datas, view, modify, sourceDialog, selectType) => {
    if (!datas || !datas.length) {
        return;
    }
    const res = await openDialog({ config: sourceDialog, selectType });
    if (!res) return;
    const rm = res.module;
    const rData = res.data;
    const module = view.getModuleCode();

    if (!rData) {
        ElMessageBox.alert('请选择目标目录', '提示：');
        return;
    }

    const relations = ModuleCenter.testRelations([module, rm]);
    if (relations.length < 2) return;
    let key = '';
    let field = '';
    let relKey = '';
    let relField = '';
    let rModule = '';
    relations[0].dest.replace(/^(\w+)\.(\w+)$/, ($0, $1, $2) => {
        rModule = $1;
        key = $2;
    })
    relations[0].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        field = $1;
    })
    relations[1].src.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relKey = $1;
    })
    relations[1].dest.replace(/^\w+\.(\w+)$/, ($0, $1) => {
        relField = $1;
    })
    const relData = {};
    relData[relKey] = rData[relField];
    const relModule = ModuleCenter.getModule(rModule);

    const modifyDatas = [];
    const ds = [];
    for (const data of datas) {
        if (modify) modifyDatas.push(Object.assign(data, modify));
        const d = Object.assign({}, relData);
        d[key] = data[field];
        ds.push(d);
    }
    if (modify && modifyDatas.length) {
        await ModuleCenter.getModule(module).editDatas(modifyDatas);
    }

    const r = await relModule.createDatas(ds);
    console.log(r);
    return r;
}

const saveRow = async (data, view) => {
    const key = view.saveData(data);
    // data[view.defaultKeyField()] = key;
}

const setDataActive = async (data, view, active) => {
    const version = view._module._dataInfo._apiVersion;
    if (version) {
        const key = view.dataKey(data, 'id');
        return view.do('/dev-api/system/' + view._module._dataInfo._refCode + '/changeStatus' + '/' + (active ? 0 : 1) + '/' + key, {}, 'put');
    } else {
        const key = view.dataKey(data, 'id');
        return view.do('/dev-api/ebk/' + view.getModuleCode() + '/approve' + '/' + (active ? 'enable' : 'unEnable') + '/' + key, {});
    }

}
const setDataActiveUser = async (data, view, active) => {
    const version = view._module._dataInfo._apiVersion;
    if (version) {
        const key = view.dataKey(data, 'userId');
        return view.do('/dev-api/system/' + view._module._dataInfo._refCode + '/changeStatus' + '/' + (active ? 0 : 1) + '/' + key, {}, 'put');
    } else {
        const key = view.dataKey(data, 'id');
        return view.do('/dev-api/ebk/' + view.getModuleCode() + '/approve' + '/' + (active ? 'enable' : 'unEnable') + '/' + key, {});
    }

}
const tatDataActive = async (data, view, active) => {
    const version = view._module._dataInfo._apiVersion;
    if (version) {
        const key = view.dataKey(data, 'id');
        return view.do('/dev-api/system/' + view._module._dataInfo._refCode + '/changeStatus' + '/' + (active ? 0 : 1) + '/' + key, {}, 'put');
    } else {
        const key = view.dataKey(data, 'id');
        return view.do('/dev-api/tat/' + view.getModuleCode() + '/approve' + '/' + (active ? 'enable' : 'unEnable') + '/' + key, {});
    }

}
const lockData = async (data, view) => {
    const key = view.dataKey(data, 'id');
    const code = view.getModuleCode();
    const module = ModuleCenter.getModule(code);
    const gateway = module.getGateway();
    const d = view.do('/dev-api/tat/' + (gateway ? '../' + gateway + '/' + code : code) + '/lock/' + '1/' + key, {});
    if (d) {
        data.lockStatus = '1';
        data.lockBy = tokenStore.username;
    }
    return d;
}
const unlockData = async (data, view) => {
    const key = view.dataKey(data, 'id');
    const code = view.getModuleCode();
    const module = ModuleCenter.getModule(code);
    const gateway = module.getGateway();
    const d = view.do('/dev-api/lms/' + (gateway ? '../' + gateway + '/' + code : code) + '/lock/' + '0/' + key, {});
    if (d) data.lockStatus = '0';
    return d;
}
const DELETECOST = async (data, view) => {
    const key = view.dataKey(data, 'id');
    const code = view.getModuleCode();
    const module = ModuleCenter.getModule(code);
    const gateway = module.getGateway();
    const d = view.do('/dev-api/lms/fmpCostStatement/cancelCostStatement/' + key, {});
    // if (d) data.lockStatus = '0';
    return d;
}

const GOSTATISTICS = async (datas, view) => {
    console.log(datas, view, props);
    let arr = [];
    for (const a of datas) {
        arr.push(a.id)
    }
    if (!datas) {
        props.queryParams.query.ids = "";
    } else {
        props.queryParams.query.ids = arr + '';
    }
    if (props.queryParams.query.payTime) {
        props.queryParams.query.startTime = props.queryParams.query.payTime[0];
        props.queryParams.query.endTime = props.queryParams.query.payTime[1];
        delete props.queryParams.query.payTime;
    }
    const querys = props.queryParams;
    const url = `/statistics/index?module=${querys}&state=${btoa(JSON.stringify(querys))}`
    enterPath(url);


}
const BATCHSTATEMENT = async (datas, view) => {
    let arrs = [];
    for (const b of datas) {
        arrs.push(b.id)
    }
    if (!datas) {
        props.queryParams.query.ids = "";
    } else {
        props.queryParams.query.ids = arrs + '';
    }
    const url = `/statistics/cost/index?module=${props.queryParams}&state=${btoa(JSON.stringify(props.queryParams))}`
    enterPath(url);
}

const processDefaultAction = async (action, selected, config) => {
    if (!config) return;

    // if (config.confirm && (await ElMessageBox.confirm(config.confirm, '提示：', { confirmButtonText: '是', cancelButtonText: '否' })) == 'cancel') return;
    if (config.dialog) {
        if (selected) {
            //Object.assign(data, await DialogManager.showDialog(config.dialog));
            const dialogData = Object.assign({}, config.dialogData, pData.value);
            if (config.parentMap) {
                const parentData = getNodeData()._parent?.data;
                if (parentData) {
                    for (const [mapField, field] of Object.entries(config.parentMap)) {
                        dialogData[mapField] = parentData[field];
                    }
                }
            }
            if (selected instanceof Array) {
                for (let i = 0; i < selected.length; i++) {
                    selected[i] = Object.assign({}, selected[i]);
                }
            } else {
                selected = Object.assign({}, selected);
            }
            if (config.dialog.selectedFieldMap) {
                const ds = selected;
                if (ds instanceof Array) {
                    for (const d of ds) {
                        for (const [mapField, field] of Object.entries(config.dialog.selectedFieldMap)) {
                            d[mapField] = d[field];
                        }
                    }
                } else {
                    for (const [mapField, field] of Object.entries(config.dialog.selectedFieldMap)) {
                        ds[mapField] = ds[field];
                    }
                }
            }
            if (config.dialog.selectedExp) {
                const ds = selected;
                if (ds instanceof Array) {
                    for (const d of ds) {
                        for (const [mapField, field] of Object.entries(config.dialog.selectedExp)) {
                            let exp = field;
                            exp = exp.replace(/data.(\w+)/g, ($0, $1) => JSON.stringify(d[$1]));
                            d[mapField] = eval(exp);
                        }
                    }
                } else {
                    for (const [mapField, field] of Object.entries(config.dialog.selectedExp)) {
                        let exp = field;
                        exp = exp.replace(/data.(\w+)/g, ($0, $1) => JSON.stringify(ds[$1]));
                        ds[mapField] = eval(exp);
                        ds[mapField] = eval(exp);
                    }
                }
            }
            if (config.dialog.dialogField) {
                if (config.dialog.keyField) {
                    if (!(selected instanceof Array)) {
                        dialogData[config.dialog.dialogField] = selected[config.dialog.keyField];
                    } else {
                        const values = [];
                        for (const s of selected) {
                            values.push(s[config.dialog.keyField]);
                        }
                        dialogData[config.dialog.dialogField] = values;
                    }
                } else dialogData[config.dialog.dialogField] = selected;
            }
            const res = await openDialog(Object.assign({}, config.dialog), config.dialogComponent, dialogData);
            if (!res) return;
            if (config.dialog.dataField) {
                selected[config.dialog.dataField] = res['data'];
            } else if (config.dialog.valueField) {
                selected[config.dialog.valueField] = res['selected'];
            } else if (config.dialog.fieldMap) {
                const d = res['data'];
                if (d instanceof Array) {
                    for (const [mapField, field] of Object.entries(config.dialog.fieldMap)) {
                        const values = [];
                        for (const da of d) {
                            values.push(da[field]);
                        }
                        selected[mapField] = values;
                    }
                } else {
                    for (const [mapField, field] of Object.entries(config.dialog.fieldMap)) {
                        selected[mapField] = d[field];
                    }
                }
            } else selected = res['data'];
        }

    }
    let url = config.url;
    let actionData = [];
    if (selected) {
        if (config.map) {
            for (const data of selected) {
                const d = {};
                for (const [mapField, field] of Object.entries(config.map)) {
                    d[mapField] = data[field];
                }
                actionData.push(d);
            }
        } else if (config?.keyField) {
            for (const data of selected) {
                actionData.push(data[config?.keyField]);
            }
        } else {
            if (selected instanceof Array) {
                actionData = [];
                for (let data of selected) {
                    actionData.push(Object.assign({}, data));
                }
            } else if (selected instanceof Object) {
                actionData = Object.assign({}, selected);
            } else {
                actionData = selected;
            }
        }
    }
    const { type, loadingState } = config;
    let d = Object.assign({}, pData.value);
    if (config?.targetField) {
        if (config.showString) {
            d[config?.targetField] = actionData.join(',');
        } else {
            d[config?.targetField] = actionData;
        }

    } else {
        d = actionData;
    }

    if (config?.parentField) {
        d[config?.parentField] = props.config?.node.getParentRelKey();
    }
    const urlInfo = formatDataUrl(url, d);
    url = addURLParams(urlInfo.url, urlInfo.params);
    d = Object.assign(d, urlInfo.body);
    const res = await RemoteCenter.remoteCall(url, config?.dataField ? d[config.dataField] : d, { type, loadingState: config.loadingState || 0 });
    if (res != -1 && config.success) {
        ElNotification({
            title: '提示',
            message: config.success,
            type: 'success',
        })
    }

    if (config.refresh) {
        queryDatas();
    }
}
const processDefaultRowAction = async (action, data, config) => {
    if (!config) return;

    if (config.dialog) {
        //Object.assign(data, await DialogManager.showDialog(config.dialog));
        // if(selected){
        //Object.assign(data, await DialogManager.showDialog(config.dialog));
        let dialogData = Object.assign({}, config.dialogData);
        if (config.dialog.selectedFieldMap) {
            const ds = data;
            if (ds instanceof Array) {
                for (const d of ds) {
                    for (const [mapField, field] of Object.entries(config.dialog.selectedFieldMap)) {
                        d[mapField] = d[field];
                    }
                }
            } else {
                for (const [mapField, field] of Object.entries(config.dialog.selectedFieldMap)) {
                    ds[mapField] = ds[field];
                }
            }
        }
        if (config.dialog.selectedExp) {
            const ds = data;
            if (ds instanceof Array) {
                for (const d of ds) {
                    for (const [mapField, field] of Object.entries(config.dialog.selectedExp)) {
                        let exp = field;
                        exp = exp.replace(/data.(\w+)/g, ($0, $1) => JSON.stringify(d[$1]));
                        d[mapField] = eval(exp);
                    }
                }
            } else {
                for (const [mapField, field] of Object.entries(config.dialog.selectedExp)) {
                    let exp = field;
                    exp = exp.replace(/data.(\w+)/g, ($0, $1) => JSON.stringify(ds[$1]));
                    ds[mapField] = eval(exp);
                    ds[mapField] = eval(exp);
                }
            }
        }
        if (config.dialog.dialogField) dialogData[config.dialog.dialogField] = [data];
        else dialogData = data;
        const res = await openDialog(config.dialog, config.dialogComponent, dialogData);
        if (!res) return;
        if (config.dialog.dataField) {
            data[config.dialog.dataField] = res['data'];
        } else if (config.dialog.valueField) {
            data[config.dialog.valueField] = res['selected'];
        } else if (config.dialog.fieldMap) {
            const d = res['data'];
            if (d instanceof Array) {
                for (const [mapField, field] of Object.entries(config.dialog.fieldMap)) {
                    const values = [];
                    for (const da of d) {
                        values.push(da[field]);
                    }
                    data[mapField] = values;
                }
            } else {
                for (const [mapField, field] of Object.entries(config.dialog.fieldMap)) {
                    data[mapField] = d[field];
                }
            }
        } else data = res['data'];
        // }
    }
    let url = config.url;
    let actionData = {};
    if (config.map) {
        for (const [mapField, field] of Object.entries(config.map)) {
            actionData[mapField] = data[field];
        }
    } else {
        Object.assign(actionData, data);
    }
    const urlInfo = formatDataUrl(url, actionData);
    url = addURLParams(urlInfo.url, urlInfo.params);
    actionData = Object.assign(actionData, urlInfo.body);
    const { type, loadingState } = config;
    const res = await RemoteCenter.remoteCall(url, actionData, { type, loadingState: config.loadingState || 0 });
    if (res != -1 && config.success) {
        ElNotification({
            title: '提示',
            message: config.success,
            type: 'success',
        })
    }
    if (config.reset) {
        queryDatas();
    }
}
const sizeChangeHandler = (value, oldValue) => {
    queryDatas()
}
const currentChangeHandler = (value, oldValue) => {
    // console.log('current change', value, oldValue);
    // if (value == 1 && oldValue == null) return;
    queryDatas();
}
const contrastData = (data, view) => {
    console.log(routeCondition)
    let index = routeCondition.findIndex(it => it.key == 'srcEntityType')
    if (index == -1) return
    const url = `/contrast/index?module=${routeCondition[index].value}&key=${view.dataKey(data, 'id')}&state='contrast'`
    enterPath(url);
}
const doExam = (data, view) => {
    // console.log(data, view)
    const startTime = (new Date(data.startTim)).getTime();
    if (startTime > TimeService.getServerTimeStamp()) {
        console.log(TimeService.getServerTimeStr())
        ElMessageBox.alert(`考试尚未开始，当前时间为${TimeService.getServerTimeStr()}，请稍候...`, '提示：')
        return;
    }

    // TableApi.postMethods('/dev-api/lms/answerPaper/startTheExam',{examId:107,examPaperId:110,isResit:'yes'})
    // let index = routeCondition.findIndex(it => it.key == 'srcEntityType')
    // if (index == -1) return
    // const url = `/#/do/index?token=${btoa(data.examId + ':' + data.questionPaperId)}&state=no`
    // console.log(url, window.location,window.location.origin + url)
    // window.open(window.location.origin + url,)
    enterUrl('/do/index', {token:btoa(data.examId + ':' + data.questionPaperId), state:'no'});
    // enterPath(url);
}
const EXAMHISTORY = (data, view) => {
    // console.log(data, view)
    // TableApi.postMethods('/dev-api/lms/answerPaper/startTheExam',{examId:107,examPaperId:110,isResit:'yes'})
    // let index = routeCondition.findIndex(it => it.key == 'srcEntityType')
    // if (index == -1) return
    const query = { token: btoa(data.examId + ':' + data.questionPaperId), state: data.score,userId:data.examinee };
    enterUrl('/do/history', query);
    // const url = `/do/history?module=${data.examId}&key=${data.questionPaperId}&state=${data.score}&userId=${data.examinee}`
    // enterPath(url);
}
const EVALUTION = (data, view) => {
    console.log(data, view)
    // TableApi.postMethods('/dev-api/lms/answerPaper/startTheExam',{examId:107,examPaperId:110,isResit:'yes'})
    // let index = routeCondition.findIndex(it => it.key == 'srcEntityType')
    // if (index == -1) return
    const url = `/evaluation?module=${data.questionPaperId}&key=${data.id}&state='yes'`
    enterPath(url);
}
const clickHandler = async (button, row) => {
    // console.log('table row click', button, row);
    const config = button.config;
    optRow.value = row;
    updateNodeData();
    const selected = DataPermissionManager.filterDatas(dataView.value.getModuleCode(), selectedRows.value);
    if (config && config.needSelect) {
        if (!selected || !selected.length) {
            ElMessageBox.alert('请在列表中选择数据', '提示：');
            return;
        }
    }
    if (config && config.confirm && (await ElMessageBox.confirm(config.confirm, '提示：', { confirmButtonText: '是', cancelButtonText: '否' })) == 'cancel') return;
    const action = button.action || button.code;
    const actionData = await props.proxy?.onAction(dataView.value.getCode() || dataView.value.getModuleCode(), getNodeData(), action);
    if (actionData) {
        if (actionData.refresh) queryDatas();
    } else {
        switch (action) {
            case 'VIEW':
                await viewData(row, dataView.value, config?.module);
                queryDatas();
                break;
            case 'VIEWREAD':
                await viewReadData(row, dataView.value, config?.module);
                queryDatas();
                break;
            case 'VIEWENTITY':
                await viewEntityData(row, dataView.value);
                queryDatas();
                break;
            case 'COLLECT':
                if (await ElMessageBox.confirm('是否添加至收藏夹中？', '提示：', { confirmButtonText: '是', cancelButtonText: '否' }) == 'cancel') return;
                if (await collect([row], dataView.value))
                    ElMessageBox.alert('已添加至收藏夹中');
                break;
            case 'COLLECT_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if (await ElMessageBox.confirm('是否添加至收藏夹中？', '提示：', { confirmButtonText: '是', cancelButtonText: '否' }) == 'cancel') return;
                if (await collect(selected, dataView.value))
                    ElMessageBox.alert('已添加至收藏夹中');
                break;
            case 'DELETE_COLLECT':
                if (await ElMessageBox.confirm('是否从收藏夹中移除？', '提示：', { confirmButtonText: '是', cancelButtonText: '否' }) == 'cancel') return;
                if (await uncollect([row], dataView.value))
                    ElMessageBox.alert('已从收藏夹中移除');
                queryDatas();
                break;
            case 'DELETE_COLLECT_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if (await ElMessageBox.confirm('是否从收藏夹中移除？', '提示：', { confirmButtonText: '是', cancelButtonText: '否' }) == 'cancel') return;
                if (await uncollect(selected, dataView.value))
                    ElMessageBox.alert('已从收藏夹中移除');
                queryDatas();
                break;
            case 'MOVEINTO':
                if (!props.filterData.data) {
                    ElMessageBox.alert('请在左侧选择目标目录');
                    return;
                }
                if (await moveInto(props.filterData, dataView.value, config?.modify, config?.source, config?.selectType)) {
                    ElMessageBox.alert('移动成功');
                }
                queryDatas();
                break;
            case 'MOVETO':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if (await moveTo(selected, dataView.value, config?.modify, config?.source, config?.selectType)) {
                    ElMessageBox.alert('移动成功');
                }
                queryDatas();
                break;
            case 'COPYTO':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if (await copyTo(selected, dataView.value, config?.modify, config?.source, config?.selectType)) {
                    ElMessageBox.alert('复制成功');
                }
                break;
            case 'COPYLINK':
                console.log('===============', row, dataView.value, config?.nameField, config?.module, '===============')
                copyLink(row, dataView.value, config?.nameField, config?.module);
                ElMessageBox.alert('链接已复制到剪贴板');
                break;
            case 'COPYPREVIEW':
                copyPreview(row, dataView.value, config?.nameField);
                ElMessageBox.alert('链接已复制到剪贴板');
                break;
            case 'CONTRAST':
                await contrastData(row, dataView.value);
                queryDatas();
                break;
            case 'DOEXAM':
                await doExam(row, dataView.value);
                break;
            case 'EXAMHISTORY':
                await EXAMHISTORY(row, dataView.value);
                break;
            case 'EVALUTION':
                await EVALUTION(row, dataView.value);
                queryDatas();
                break;
            //EVALUTION
            case 'MODIFY_SAVE':
                const md = await modifySaveData(row, dataView.value, config.modify);
                if (md && config.alert) ElMessageBox.alert(config.alert, '提示：');
                else if (button.code == 'PASS') {
                    await saveResourceRecord(row, 'approve', '审核通过');
                    ElMessageBox.alert('发布成功！', '提示：');
                } else if (button.code == 'REFUSE') {
                    await saveResourceRecord(row, 'approve', '审核被拒绝');
                    ElMessageBox.alert('审核已拒绝通过！', '提示：');
                }
                queryDatas();
                break;
            case 'MODIFY_SAVE_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                const mdb = await modifySaveDatas(selected, dataView.value, config.modify);
                if (mdb && config.alert) ElMessageBox.alert(config.alert, '提示：');
                else if (button.code == 'PASS') {
                    await saveResourceRecord(selected, 'approve', '审核通过');
                    ElMessageBox.alert('发布成功！', '提示：');
                } else if (button.code == 'REFUSE') {
                    await saveResourceRecord(selected, 'approve', '审核被拒绝');
                    ElMessageBox.alert('审核已拒绝通过！', '提示：');
                }
                queryDatas();
                break;
            case 'EDIT':
                await editData(row, dataView.value);
                queryDatas();
                break;
            case 'DELETE':
                if (config?.confirm) {
                    if ((await ElMessageBox.confirm(config.confirm, '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                } else if ((await ElMessageBox.confirm('是否删除当前数据？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteDatas([row], dataView.value, config?.rels);
                if (button.code == 'REMOVE_RESOURCE') {
                    await saveResourceRecord(row, 'update', '已删除', 1);
                }
                queryDatas();
                updateFilter();
                break;
            
            case 'DELETE_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                const rows = selected;
                if (config?.confirm) {
                    if ((await ElMessageBox.confirm(config.confirm, '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                } else if ((await ElMessageBox.confirm('是否删除选中数据？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                const r = await deleteDatas(rows, dataView.value, config?.rels);
                console.log(r);
                if (button.code == 'REMOVE_RESOURCE') {
                    await saveResourceRecord(rows, 'update', '已删除', 1);
                }
                queryDatas();
                updateFilter();
                break;
            case 'DELETEREL':
                if ((await ElMessageBox.confirm('是否删除当前关联记录？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteRels([row], dataView.value);
                queryDatas();
                break;
            case 'ANSERDELETE':
            if ((await ElMessageBox.confirm('是否删除当前关联记录？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteRels([row], dataView.value);
                await remoteCall('/dev-api/lms/questionPaper/calculate', { params: null, data: {questionPaperId:getNodeData()._parent?.data.id}, loadingState: 0 }, true);
                queryDatas();
                break;
            case 'DELETETREEREL':
                if ((await ElMessageBox.confirm('是否删除当前关联记录？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteTreeRels(props.filterData, [row], dataView.value);
                queryDatas();
                break;
            case 'DELETEREL_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if ((await ElMessageBox.confirm('是否删除选中关联记录？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteRels(selected, dataView.value);
                queryDatas();
                break;
            case 'ANSERDELETEREL_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if ((await ElMessageBox.confirm('是否删除选中关联记录？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteRels(selected, dataView.value);
                await remoteCall('/dev-api/lms/questionPaper/calculate', { params: null, data: {questionPaperId:getNodeData()._parent?.data.id}, loadingState: 0 }, true);
                queryDatas();
                break;
            case 'DELETETREEREL_BATCH':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                if ((await ElMessageBox.confirm('是否删除选中关联记录？', '提示：', { confirmButtonText: '是', cancelButtonText: '否', type: 'warning' })) == 'cancel') return;
                await deleteTreeRels(props.filterData, selected, dataView.value);
                queryDatas();
                break;
            case 'ADDROOT':
                await addRootData(props.filterData, config?.default || props.config?.default || {}, dataView.value, config?.route);
                queryDatas();
                updateFilter();
                break;
            case 'ADDCHILD':
                if (!props.filterData.data || !props.filterData.data.id) {
                    ElMessageBox.alert('请选择上级分类！', '提示：');
                    return;
                }
                await addChildData(props.filterData, config?.default || props.config?.default || {}, dataView.value, config?.route);
                queryDatas();
                updateFilter();
                break;
            case 'ADDCHILDDEPT':
                if (!props.filterData.data) {
                    ElMessageBox.alert('请选择上级部门！', '提示：');
                    return;
                }
                await addChildData(props.filterData, config?.default || props.config?.default || {}, dataView.value, config?.route);
                queryDatas();
                updateFilter();
                break;
            case 'INTOLIST':
                if (!props.filterData.data) {
                    ElMessageBox.alert('请在左侧树选择题目所属能力', '提示：');
                    return;
                }
                if (props.filterData.data && props.filterData.data.level != 2) {
                    ElMessageBox.alert('当前分类不能创建题目!', '提示：');
                    return;
                }
                if (await moveInto(props.filterData, dataView.value, config?.modify, config?.source, config?.selectType)) {
                    ElMessageBox.alert('移动成功');
                }
                queryDatas();
                break;
            // case 'ADDQ':
            //     if (!props.filterData.data) {
            //         ElMessageBox.alert('请选择题目类型', '提示：');
            //         return;
            //     }
            //     if (props.filterData.data && props.filterData.data.level != 2) {
            //         ElMessageBox.alert('当前分类不能创建题目!', '提示：');
            //         return;
            //     }
            //     await addData(config?.default || props.config?.default || {}, dataView.value, config?.route);
            //     queryDatas();
            //     break;
            case 'ADD':
                await addData(config?.default || props.config?.default || {}, dataView.value, config?.route);
                queryDatas();
                break;
            case 'TRYRESOURCE':
                await TRYRESOURCE(selected, dataView.value);
                queryDatas();
                break;
            case 'TATTRYRESOURCE':
                await TATTRYRESOURCE(selected, dataView.value);
                queryDatas();
                break;
            case 'ADDDATAS':
                if (!props.filterData.data) {
                    ElMessageBox.alert('请选择上级节点', '提示：');
                    return;
                }
                await addDatas(dataView.value, config?.source);
                queryDatas();
                break;
            case 'ADDTARGETDATAS':
                const tasks = await addTargetDatas(row, dataView.value, config?.target, config?.targetMap, config?.source);
                if(tasks) ElMessageBox.alert('下发任务成功！');
                queryDatas();
                break;
            case 'ADDSELECTTARGETDATAS':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                await addSelectTargetDatas(selected, dataView.value, config?.modify, config?.target, config?.targetMap, config?.source, config?.selectType);
                queryDatas();
                break;
            case 'ADDDATASWITHPARENT':
                await addDatasWithParent(Object.assign({}, getNodeData()._parent?.data, config?.default || props.config?.default || {}), dataView.value, config?.module, config?.fieldMap, config?.source, config?.selectType);
                queryDatas();
                break;
            case 'ADDRELS':
                await addRels(dataView.value, config?.source, config?.modify);
                queryDatas();
                break;
            case 'ANSERADDRELS':
                console.log(dataView,'====================')
                await addRels(dataView.value, config?.source, config?.modify);
                queryDatas();
                // let per = {questionPaperId:}
                break;
            case 'ADDTREERELS':
                if (!props.filterData.data) {
                    ElMessageBox.alert('请选择目录', '提示：');
                    return;
                }
                await addTreeRels(props.filterData, dataView.value, config?.source, config?.modify);
                queryDatas();
                break;
            case 'ADDWITHPARENT':
                const parentData = getNodeData()._parent?.data;
                const map = button.config?.fieldMap;
                await addDataWithParent(Object.assign({}, parentData, config?.default || props.config?.default || {}), map, dataView.value);
                queryDatas();
                break;
            case 'DOWNLOAD':
                download(row, dataView.value);
                break;
            case 'TABDOWN':
                TABDOWN(selected, dataView.value);
                break;
            case 'EXPORT':
                TABLEEXPORT(selected, dataView.value);
                break;
            case 'ACTIVATE':
                await activeData(row, dataView.value);
                queryDatas();
                break;
            case 'DEACTIVATE':
                await deactiveData(row, dataView.value);
                queryDatas();
                break;
            case 'ACTIVATEUSER':
                await activeDataUser(row, dataView.value);
                queryDatas();
                break;
            case 'DEACTIVATEUSER':
                await deactiveDataUser(row, dataView.value);
                queryDatas();
                break;
            case 'ACTIVATETAT':
                await activeDatatat(row, dataView.value);
                queryDatas();
                break;
            case 'DEACTIVATETAT':
                await deactiveDatatat(row, dataView.value);
                queryDatas();
                break;
            case 'INVALID':
                await invalidData(row, dataView.value);
                break;
            case 'READS':
                if (!selected || !selected.length) {
                    ElMessageBox.alert('请在列表中选择数据', '提示：');
                    return;
                }
                await reads(selected, dataView.value);
                queryDatas();
                break;
            case 'CLOSE':
                await closeData(row, dataView.value);
                break;
            case 'STATISTICS':
                await summaryDatas(selectedRows.value, dataView.value);
                break;
            case 'LOCK':
                await lockData(row, dataView.value);
                break;
            case 'UNLOCK':
                await unlockData(row, dataView.value);
                break;
            case 'DELETECOST':
                await DELETECOST(row, dataView.value);
                break;
            case 'BATCHCOLLECT':
                await GOSTATISTICS(selected, dataView.value);
                queryDatas();
                break;
            case 'BATCHSTATEMENT':
                await BATCHSTATEMENT(selected, dataView.value);
                queryDatas();
                break;
            case 'LINK':
                goLink(row, dataView.value, config);
                break;
            default:
                if (row) processDefaultRowAction(action, row, config);
                else processDefaultAction(action, selected, config);
                break;
        }

    }
}
const linkClickHandler = (value, row, config) => {
    if (row.link) {
        const field = row.link.field || ModuleCenter.getModule(row.link.module).defaultKeyField();
        DefaultActions.doEnter(ViewState.VIEW, row.link.module, field, row.link.value);
    } else if (config.path) {
        const relInfo = config.path[config.path.length - 1];
        const field = config.path[config.path.length - 2].field._relFieldCode;
        DefaultActions.doEnter(ViewState.VIEW, relInfo.module.getCode(), field, value);

    } else {
        const dataView = props.config?.view;
        const dataField = dataView.getDataField(config.field);
        let relInfo = dataField.getRelatedInfo();
        if (!relInfo && dataField._dynamicRelInfo && dataField._dynamicRelInfo.length) {
            const typeField = dataView.getModule()._bindEntity.typeField;
            const dynamicModule = row[typeField];
            relInfo = dataField.getDynamicRelatedInfoBy(dynamicModule);
        }
        if (relInfo) {
            DefaultActions.doEnter(ViewState.VIEW, relInfo.module.getCode(), relInfo.field.getCode(), value);
        } else {
            viewData(row, dataView);
        }
    }
}

onMounted(() => {
})
watch(() => props.queryParams, (value) => {
    pagination.pageNumber = 1;
    queryDatas();
}, { deep: true });

const getTableData = (key, keyField) => {
    for (const data of modelDatas.value) {
        if (key == data[keyField]) return data;
    }
    return null;
}
const getTableDatas = async (keys, keyField) => {
    if (!keys || !modelDatas.value) return [];
    const datas = [];
    for (const key of keys) {
        let data = getTableData(key, keyField);
        if (!data) data = await dataView.value.getByKey(key, keyField);
        if (data) datas.push(data);
    }
    return datas;
}

const changeRowsSelect = async (rows, selected) => {
    let datas = [...(props.selected || [])];
    // if (selectedRows.value) datas = datas.concat(selectedRows.value);
    const keyField = props.config?.keyField || dataView.value.defaultKeyField();
    const keys = dataView.value.datasKeys(datas, keyField);
    for (const row of rows) {
        const value = row[keyField];
        if (selected) {
            const index = keys.indexOf(value);
            if (index < 0) keys.push(value);
        } else {
            const index = keys.indexOf(value);
            if (index >= 0) keys.splice(index, 1);
        }
    }
    const values = await getTableDatas(keys, keyField);
    selectedRows.value = values;
    inst.emit('update:selected', values);
}

const selectHandler = async (row, selected) => {
    if (props.config?.selectType != SelectType.SINGLE_SELECT) {
        changeRowsSelect([row], selected);
    } else {
        // const keyField = props.config?.keyField || dataView.value.defaultKeyField();
        selectedRows.value = row;
        inst.emit('update:selected', selected ? row : null);
    }
}
const selectionHandler = async (rows, selected) => {
    changeRowsSelect(rows, selected);
}
</script>
<style scoped>
.x-table-pagination {
    float: right;
    padding: 10px;
}

.x-table-view.xm-table {
    background: #fff;
}

.x-table-view>>>.el-table-column--selection>.cell {
    padding: 0;
}

.x-table-view>.no-pagination {
    margin: 10px;
}

.xm-table-button {
    padding: 10px;
}
</style>
<style>
.x-table-row-editor .el-button {
    margin: 0 !important;
}

.x-table-row-editor-trigger {
    width: 16px;
    height: 42px;
    border-radius: 0;
    /*border-right: 1px solid transparent;
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;*/
    background: none;
}
</style>